
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.99996 10V14C9.99996 14.55 10.45 15 11 15C11.55 15 12 14.55 12 14V4H14V14C14 14.55 14.45 15 15 15C15.55 15 16 14.55 16 14V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2H10.17C8.07996 2 6.21996 3.53 6.01996 5.61C5.78996 7.99 7.65996 10 9.99996 10ZM7.99996 17V15.21C7.99996 14.76 7.45996 14.54 7.14996 14.86L4.35996 17.65C4.15996 17.85 4.15996 18.16 4.35996 18.36L7.14996 21.15C7.45996 21.46 7.99996 21.24 7.99996 20.79V19H19C19.55 19 20 18.55 20 18C20 17.45 19.55 17 19 17H7.99996Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-format-textdirection-r-to-l`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFormatTextdirectionRToL

    ```js
    <b-new-b-icon-format-textdirection-r-to-l />
    ```
</docs>


